module.exports = __webpack_public_path__ + "img/school.118acc4c.png";